<script setup lang="ts">
import { usePopoverStore } from "@/store/popover";

const popoverStore = usePopoverStore();

const popover = computed(() => popoverStore.getPopover);

const handleClose = () => {
	popoverStore.hidePopover();
};
</script>

<template>
	<!-- :style="`height: ${popover?.height}`" -->
	<p-drawer
		v-model:visible="popoverStore.isVisible"
		position="bottom"
		:header="popover?.title"
		style="height: auto"
		:pt="{
			root: {
				style: 'border-radius: 10px 10px 0 0;',
			},
		}"
		@hide="handleClose"
	>
		<template
			v-if="popover?.header"
			#header
		>
			<div class="header-wrap">
				<component :is="popover.header.icon" />
				<span>{{ popover.header.title }}</span>
			</div>
		</template>
		<component
			:is="popover.comp"
			v-bind="popover.props"
			@close-modal="handleClose"
		/>
	</p-drawer>
</template>

<style scoped lang="scss">
.header-wrap {
	display: flex;
	align-items: center;
	gap: 10px;

	svg {
		width: 20px;
		height: 20px;
	}

	span {
		font-size: 0.875rem;
		font-weight: 500;
	}
}
</style>
